<ng-container [caLocalizationScope]="localizationKey">
  <i
    fMobilePopover
    [ngbPopover]="'notTargetedInfo' | caLocalize"
    triggers="hover focus"
    container="body"
    class="f-i f-i-xs f-i-info text-muted cursor-default"
  >
  </i>
</ng-container>
